import { createContext } from "react";

const WindowSizeContext = createContext();

export default WindowSizeContext;